<template>
  <!-- 年度分析报告表格 -->
  <div class="page analysisReport">
    <div class="pageTable analysisReport_box">
      <div class="hearder_title">
        <p class="headline2" v-if="getZykInformation.zykName.length > 18">{{getZykInformation.zykName}}专业教学资源库基本报告（{{getZykInformation.zykNum}}）</p>
        <p class="headline" v-else>{{getZykInformation.zykName}}专业教学资源库基本报告（{{getZykInformation.zykNum}}）</p>
        <p class="distinguish">
          <!-- <span>主持单位：{{getZykInformation.hostUnit}}<span v-if="getZykInformation.coHostUnit.length != 0">，</span><span v-for="(item,index) in getZykInformation.coHostUnit" :key="index">{{index == getZykInformation.coHostUnit.length-1 && item || (item + '，') }}</span></span> -->
          <span>主持单位：{{getZykInformation.allHostUnit}}</span>
          <span>数据截止时间：{{getZykInformation.endTime}}</span>
          <!-- <span>数据截止时间：2022-10-15</span> -->
        </p>
        <div class="lineBox">
          <p></p>
          <p></p>
        </div>
      </div>

      <table border="1" cellspacing="0" cellpadding="0" class="tables" style="border: none;">
        <tr>
          <th class="borderBaise " style="width: 9%;">一级指标</th>
          <th class="borderBaise borderLeft" style="width: 24%;">二级指标</th>
          <th class="borderBaise borderLeft borderRight" style="width: 46;">三级指标</th>
          <th class="borderBaise" colspan="6" style="width: 21%;">统计值</th>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="10">用户</td>
          <td class="borderBaise borderTop borderLeft" rowspan="10">用户总数</td>
          <td>注册用户数（教师+学生）</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.registerUserCount}}</td>
        </tr>
        <tr>
          <td>主持院校已实名教师数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.presideSchoolRealnameTeacherCount}}</td>
        </tr>
        <tr>
          <td>主持院校已实名教师占比</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.presideSchoolRealnameTeacherCountPercentage}}</td>
        </tr>
        <tr>
          <td>建设院校已实名教师数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.realnameTeacherCount}}</td>
        </tr>
        <tr>
          <td>建设院校已实名教师总使用天数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.realnameTeacherDaySum}}</td>
        </tr>
        <tr>
          <td>建设院校实名教师近三年无活动记录教师数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.noActiveRealnameTeacherCount}}</td>
        </tr>
        <tr>
          <td>建设院校实名教师无活动记录占比</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.noActiveRealnameTeacherPercentage}}</td>
        </tr>
        <tr>
          <td>建设院校近三年注册并已实名学生数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.realnameStudentCount}}</td>
        </tr>
        <tr>
          <td>建设院校已实名学生总使用天数</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{userTotal.realnameStudentDaySum}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft borderRight">建设院校近三年注册并已实名学生中无活动记录学生数</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.noActiveRealnameStudentCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="20">资源</td>
          <td class="borderBaise borderTop borderLeft" rowspan="13">资源总数</td>
          <td>总量</td>
          <td class="borderBaise borderTop borderBottom" colspan="2">{{material.resourceCount}}</td>
        </tr>
        <tr>
          <td>文本类/图形图像</td>
          <td class="borderBaise borderTop borderBottom borderRight" style="width: 10%;">{{material.textVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft" style="width: 10%;">{{material.textVo.percentage}}</td>
        </tr>
        <tr>
          <td>文本型演示文稿（ppt、网页课件与富媒体等）</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.textPPTVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.textPPTVo.percentage}}</td>
        </tr>
        <tr>
          <td>动画类</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.animationVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.animationVo.percentage}}</td>
        </tr>
        <tr>
          <td>虚拟仿真类</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.virtualVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.virtualVo.percentage}}</td>
        </tr>
        <tr>
          <td>音频类</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.audioVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.audioVo.percentage}}</td>
        </tr>
        <tr>
          <td>视频类</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.videoVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.videoVo.percentage}}</td>
        </tr>
        <tr>
          <td>微课类</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.smallCourseVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.smallCourseVo.percentage}}</td>
        </tr>
        <tr>
          <td>其他</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.otherVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.otherVo.percentage}}</td>
        </tr>
        <tr>
          <td>原创资源占比</td>
          <!-- <td class="borderBaise borderTop borderBottom borderRight">{{material.originVo.sumValue}}</td> -->
          <td class="borderBaise borderTop borderBottom borderLeft" colspan="2">{{material.originVo.percentage}}</td>
        </tr>
        <tr>
          <td>资源被课程引用的占比</td>
          <!-- <td class="borderBaise borderTop borderBottom borderRight">{{material.courseResourceVo.sumValue}}</td> -->
          <td class="borderBaise borderTop borderBottom borderLeft" colspan="2">{{material.courseResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td>题库题目使用率</td>
          <!-- <td class="borderBaise borderTop borderBottom borderRight">{{material.questionVo.sumValue}}</td> -->
          <td class="borderBaise borderTop borderBottom borderLeft" colspan="2">{{material.questionVo.percentage}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft borderRight">无访问记录总数</td>
          <td class="borderBaise borderTop borderRight">{{material.noActiveResourceCountVo.sumValue}}</td>
          <td class="borderBaise borderTop borderLeft">{{material.noActiveResourceCountVo.percentage}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft">素材资源使用总次数</td>
          <td class="borderBaise borderTop borderLeft borderRight">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{material.resourceLogCount}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="5">素材资源应用情况</td>
          <td>浏览资源</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.viewResourceVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.viewResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td>评价资源</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.commentResourceVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.commentResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td>下载资源</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.downloadResourceVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.downloadResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td>收藏资源</td>
          <td class="borderBaise borderTop borderBottom borderRight">{{material.collectionResourceVo.sumValue}}</td>
          <td class="borderBaise borderTop borderBottom borderLeft">{{material.collectionResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft borderRight">其他</td>
          <td class="borderBaise borderTop borderRight">{{material.otherResourceVo.sumValue}}</td>
          <td class="borderBaise borderTop borderLeft">{{material.otherResourceVo.percentage}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft">素材资源平均被使用次数</td>
          <td class="borderBaise borderTop borderLeft borderRight">平均值</td>
          <td class="borderBaise borderTop" colspan="2">{{material.averageResourceLogCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="4">课程</td>
          <td class="borderBaise borderTop borderLeft">标准化课程</td>
          <td class="borderBaise borderTop borderLeft borderRight">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{courses.courseBzNum}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft">无访问标准化课程数</td>
          <td class="borderBaise borderTop borderLeft borderRight">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{courses.jsCourseBzNum}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft">标准化课程的选课用户总数</td>
          <td class="borderBaise borderTop borderLeft borderRight">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{courses.courseBzUserNum}}</td>
        </tr>
        <tr>
          <td class="borderBaise borderTop borderLeft">标准化课程课程开课期数</td>
          <td class="borderBaise borderTop borderLeft borderRight">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{courses.courseTime}}</td>
        </tr>

        <tr>
          <td colspan="8" style="border: none;"></td>
        </tr>
        <tr>
          <td colspan="8" style="border: none;"></td>
        </tr>
        <tr>
          <td colspan="8" style="border: none;"></td>
        </tr>
        <tr>
          <td colspan="8" style="border: none;"></td>
        </tr>

        <tr v-for="(item,index) in distribution" :key="index+0.1">
          <td class="borderBaise" v-show="index == 0" rowspan="14">应用情况</td>
          <td class="borderBaise borderLeft" v-show="index == 0" :rowspan="distribution.length">用户访问行为分布</td>
          <td v-if="index == distribution.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != distribution.length-1 && index != 0">{{item.action}}</td>
          <td v-if="index == 0" class="borderBaise borderBottom borderLeft borderRight">{{item.action}}</td>
          <td v-if="index == distribution.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != distribution.length-1 && index != 0" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
          <td v-if="index == 0" class="borderBaise borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in forum" :key="index+0.2">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="forum.length">论坛情况</td>
          <td class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td class="borderBaise borderTop" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in conditions" :key="index+0.3">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="conditions.length">作业情况</td>
          <td v-if="index == conditions.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != conditions.length-1">{{item.action}}</td>
          <td v-if="index == conditions.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != conditions.length-1" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in situation" :key="index+0.4">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="situation.length">考试情况</td>
          <td v-if="index == situation.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != situation.length-1">{{item.action}}</td>
          <td v-if="index == situation.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != situation.length-1" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(itemobj6,indexObj6) in userUpdateobj.usersOverTheYears" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='userUpdateobj.usersOverTheYears.length + 1' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='userUpdateobj.usersOverTheYears.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除用户数</td>
          <td class="borderBaise borderTop borderLeft borderRight">删除用户总数</td>
          <td colspan="6" class="borderBaise borderTop">{{userUpdateobj.usersDeleted}}</td>
        </tr>

        <tr v-for="(itemobj7,indexObj7) in resourceUpdate.resourcesYears" :key="indexObj7+0.6">
          <td class="borderBaise borderTop" :rowspan='resourceUpdate.resourcesYears.length + 1 + resourceUpdate.renewalRate.length+1' v-if="itemobj7.oneLevel">{{itemobj7.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.resourcesYears.length' v-if="itemobj7.secondLevel">{{itemobj7.secondLevel}}</td>
          <td v-if="indexObj7 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj7.yearUpdate}}</td>
          <td v-if="indexObj7 != resourceUpdate.resourcesYears.length-1">{{itemobj7.yearUpdate}}</td>
          <td v-if="indexObj7 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj7.num}}</td>
          <td v-if="indexObj7 != resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj7.num}}</td>
        </tr>

        <tr v-for="(itemobj8,indexObj8) in resourceUpdate.renewalRate" :key="indexObj8+0.6">
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.renewalRate.length' v-if="itemobj8.secondLevel">{{itemobj8.secondLevel}}</td>
          <td v-if="indexObj8 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 != resourceUpdate.renewalRate.length-1">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj8.num}}</td>
          <td v-if="indexObj8 != resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj8.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除资源数</td>
          <td class="borderBaise borderTop borderLeft borderRight">删除资源总数</td>
          <td class="borderBaise borderTop" colspan="6">{{resourcesDeleted}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getBasicReportUserVoObj: {}, // 一级指标用户
      getStatResourceDataEntityobj: {}, // 素材资源
      recordsnumber: 0, // 无访问记录总数
      citednumber: 0, // 资源被课程引用的占比
      materialsNum: 0, // 素材资源使用总次数
      visitsNum: 0, // 访问总量
      situationNum: 0, // 论坛情况
      conditionNum: 0, // 作业情况
      examinationNum: 0, // 考试情况
      getResourceApplicationVoobj: { // 1-素材资源应用情况，2-用户访问行为分布,3-论坛情况,4-作业情况,5-考试情况
        obj1: [],
        obj2: [],
        obj3: [],
        obj4: [],
        obj5: [],
      },
      getCourseCountVoObj: {}, // 课程

      getZykInformation: { // 头部基本信息
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: '',
      },
      userTotal: { // 用户总数
        registerUserCount: '',
        presideSchoolRealnameTeacherCount: '',
        presideSchoolRealnameTeacherCountPercentage: '',
        realnameTeacherCount: '',
        realnameTeacherDaySum: '',
        noActiveRealnameTeacherCount: '',
        noActiveRealnameTeacherPercentage: '',
        realnameStudentCount: '',
        realnameStudentDaySum: '',
        noActiveRealnameStudentCount: '',
      },
      material: { // 获取素材资源,素材资源使用总次数,素材资源应用情况,平均每个资源使用次数
        resourceCount: '',
        textVo: {
          percentage: '',
          sumValue: '',
        },
        textPPTVo: {
          percentage: '',
          sumValue: '',
        },
        animationVo: {
          percentage: '',
          sumValue: '',
        },
        virtualVo: {
          percentage: '',
          sumValue: '',
        },
        audioVo: {
          percentage: '',
          sumValue: '',
        },
        videoVo: {
          percentage: '',
          sumValue: '',
        },
        smallCourseVo: {
          percentage: '',
          sumValue: '',
        },
        otherVo: {
          percentage: '',
          sumValue: '',
        },
        originVo: {
          percentage: '',
          sumValue: '',
        },
        noActiveResourceCountVo: {
          percentage: '',
          sumValue: '',
        },
        courseResourceVo: {
          percentage: '',
          sumValue: '',
        },
        questionVo: {
          percentage: '',
          sumValue: '',
        },
        resourceLogCount: '',
        viewResourceVo: {
          percentage: '',
          sumValue: '',
        },
        commentResourceVo: {
          percentage: '',
          sumValue: '',
        },
        downloadResourceVo: {
          percentage: '',
          sumValue: '',
        },
        collectionResourceVo: {
          percentage: '',
          sumValue: '',
        },
        otherResourceVo: {
          percentage: '',
          sumValue: '',
        },
        averageResourceLogCount: '',
      },
      courses: { // 标准化课程,无访问标准化课程数,标准化课程的选课用户总数,标准化课程课程开课期数
        courseBzNum: '',
        jsCourseBzNum: '',
        courseBzUserNum: '',
        courseTime: '',
      },

      distribution: [], // 用户访问行为分布
      forum: [], // 论坛情况
      conditions: [], // 作业情况
      situation: [], // 考试情况

      userUpdateobj: { // 用户更新（历年新增用户数，删除用户数）
        usersOverTheYears: [],
        usersDeleted: 0,
      },

      resourceUpdate: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        resourcesYears: [],
      },

      resourceUpdate1: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        // resourcesYears: [],
      },
      resourceUpdate2: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        // resourcesYears: [],
      },
      resourcesDeleted: 0, // 删除资源数
      endTime: '',
      startTime: ''
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem('lrmv2token', token)
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid)
    }
    setTimeout(() => {
      this.getZykInformationVo();
      this.getBasicReportUserVo();
      this.getBasicReportResourceVo();
      this.getCourseCountVo();
      this.distributionVo();
      this.forumVo();
      this.conditionsVo();
      this.situationVo();

      // this.usersOverTheYearss();
      this.usersDeleteds();
      // this.resourcesYearss();
      // this.renewalRates();
      this.resourcesDeleteds();
    }, 1000)
  },
  methods: {
    // 切换专业
    dataChange(e) {
      this.$axios.post(this.$apiurls.major_switch, e, {
        loading: false,
      }).then((res) => {
        if (res.data) {
          sessionStorage.setItem('zykId', e)
          this.reload();
        }
      });
    },
    reload() {  //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    // 获取报告基本信息
    getZykInformationVo() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.getZykInformation = res.data;
          this.getZykInformation.allHostUnit = res.data.allHostUnit.replaceAll(',', '，');

          this.usersOverTheYearss();
          this.resourcesYearss();
          this.renewalRates();

          // this.$nextTick(() => {
          //   this.endTime = this.getZykInformation.endTime.slice(0, 7)
          //   this.startTime = this.getZykInformation.startTime.slice(0, 7)
          // })


        }
      });
    },

    // 获取用户总数
    getBasicReportUserVo() {
      this.$axios.post(this.$apiurls.report_year_getBasicReportUserVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userTotal = res.data;
        }
      });
    },

    // 获取素材资源,素材资源使用总次数,素材资源应用情况,平均每个资源使用次数
    getBasicReportResourceVo() {
      this.$axios.post(this.$apiurls.report_year_getBasicReportResourceVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.material = res.data;
        }
      });
    },

    // 标准化课程,无访问标准化课程数,标准化课程的选课用户总数,标准化课程课程开课期数
    getCourseCountVo() {
      this.$axios.post(this.$apiurls.report_year_getCourseCountVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.courses = res.data;
        }
      });
    },

    // 用户访问行为分布
    distributionVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.distribution = res.data;
        }
      });
    },

    // 论坛情况
    forumVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 3, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.forum = res.data;
        }
      });
    },

    // 作业情况
    conditionsVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 4, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.conditions = res.data;
        }
      });
    },
    // 考试情况
    situationVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 5, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.situation = res.data;
        }
      });
    },

    // 获取用户更新历年新增用户数
    usersOverTheYearss() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo + `?statType=1`, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '用户更新';
              res.data[i].secondLevel = '历年新增用户数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }
          this.userUpdateobj.usersOverTheYears = res.data;
        }
      });
    },

    // 获取用户更新删除用户数
    usersDeleteds() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userUpdateobj.usersDeleted = res.data;
        }
      });
    },

    // 获取资源更新历年新增资源数
    resourcesYearss() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo + `?statType=3`, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '资源更新';
              res.data[i].secondLevel = '历年新增资源数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }

          this.resourceUpdate.resourcesYears = res.data;
        }
      });
    },

    // 获取资源更新同比上一年资源更新率
    renewalRates() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo + `?statType=2`, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '同比上一年资源更新率';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.resourceUpdate.renewalRate = res.data;
        }
      });
    },

    // 获取资源更新删除资源数
    resourcesDeleteds() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourcesDeleted = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

.analysisReport_box {
  width: 95% !important;
  margin: 0px auto;
  height: 5385px !important;
}

.page {
  background: #fff;
}
.pageTable {
  width: 75%;
  height: auto;
  margin: 40px auto 50px;
}
.hearder_title {
  text-align: center;
  font-weight: 700;
  font-size: 15px;
}

.headline {
  font-size: 39px;
  font-weight: bold;
  /* color: #1d244e; */
  color: #000;
  line-height: 150px;
  margin-top: 41px;
}

.headline2 {
  font-size: 35px;
  font-weight: bold;
  /* color: #1d244e; */
  color: #000;
  line-height: 150px;
  margin-top: 41px;
}

.distinguish {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  /* color: #707f9d; */
  color: #000;
  font-size: 17px;
  font-weight: 400;
  font-size: 30px;
}

.lineBox {
  margin-bottom: 40px;
}
.lineBox p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  padding: 0px;
  margin: 0px;
  margin-top: 8px;
}
.lineBox p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.tables {
  width: 100%;
  text-align: center;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr {
  height: 67px;
  /* color: #566178; */
  color: #000;
  font-size: 30px;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr:first-child {
  background: rgba(204, 204, 204, 0.403);
}

.el-backtop.backtops {
  background: #66adff;
}

.el-backtop,
.el-calendar-table td.is-today {
  color: #fff;
}

.borderBaise {
  border: 2px solid #b6b6b6;
}

.borderTop {
  border-top-width: 1px;
}

.borderBottom {
  border-bottom-width: 1px;
}

.borderLeft {
  border-left-width: 1px;
}

.borderRight {
  border-right-width: 1px;
}
</style>
